import './index.scss'
// import './themes/kendo-theme-custom.scss'
import '@progress/kendo-theme-material'

import { ProSidebarProvider } from 'react-pro-sidebar'
import { StylesProvider } from '@material-ui/core/styles'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'

import { store } from './app/store'
import { needsSave } from './features/order/orderSlice'
import Router from './router'
import * as serviceWorker from './serviceWorker'

// import 'resize-observer-polyfill'

// import './wdyr' // <--- first import
// import '@fontsource/roboto'
// const unsubscribe = store.subscribe(() => {
// })
// unsubscribe();

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );
// Temporarily removing StrictMode to get Kendo's Grid Column Resizer to work.

// IMPORTANT: disables default browser on drop -- typically opens files in browser
window.ondragover = function (e) {
    e.preventDefault()
    return false
}
window.ondrop = function (e) {
    e.preventDefault()
    return false
}

window.onbeforeunload = () => {
    let needsPrompt = needsSave()
    if (!needsPrompt) return
    return 'There are unsaved changes. Leave anyway?'
}

// const queryString = window.location.search
// const urlParams = new URLSearchParams(queryString)
// let warehouseParam = urlParams.get('wh')
// let companyCode = urlParams.get('co')
// let qsTagUID = urlParams.get('u')

// localhost doesnt have the cookie
// if (
//     !document.cookie.includes('WalkThruId') &&
//     !window.location.href.includes('localhost') &&
//     !(warehouseParam && companyCode)
// ) {
//     // assuming this means not logged in
//     //
//     if (isWebUser()) {
//         window.location.href = `/logon.aspx?redirect=${encodeURIComponent(window.location.href)}`
//     } else
//         window.location.href = `${getBaseURL()}masterclient/main.aspx?redirect=${encodeURIComponent(
//             getBaseURL()
//         )}${window.location.pathname}`
// }

// IMPORTANT!! Don't do createRoot cause of kendo-dateinputs until updated to >5.14.1
// ** Related issue: https://github.com/telerik/kendo-react/issues/1566
// const root = createRoot(document.getElementById('root'))
// root.render(
//     <Provider store={store}>
//         <StylesProvider injectFirst>
//             <ProSidebarProvider>
//                 <Router />
//             </ProSidebarProvider>
//         </StylesProvider>
//     </Provider>
// )
ReactDOM.render(
    <Provider store={store}>
        <StylesProvider injectFirst>
            <ProSidebarProvider>
                <Router />
            </ProSidebarProvider>
        </StylesProvider>
    </Provider>,
    document.getElementById('root')
)

if (window.Cypress) {
    window.store = store
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
